import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { CCEuro24GameId } from '../../../constants';
import { MonitorLoader } from './monitor-loader';
import { IChancyLoader } from './ichancy-loader';
import { CashierLoader } from './cashier-loader';
import { DefaultLoader } from './default-loader';
import { LaunchType } from '../../../enums';
import { useStore } from '../../../hooks';

interface GlobalLoaderProps {}

export const GlobalLoader: React.FC<GlobalLoaderProps> = observer(() => {

  const { gameStore, loaderStore } = useStore();
  const { isTronix, launchData: { data: launchData }, gameId } = gameStore;
  const { launchType, disableLoader, hasPascalLoader } = launchData || {};

  const loaders = useMemo<Partial<Record<LaunchType, React.FC>>>(() => ({
    [LaunchType.Cashier]: () => <CashierLoader disableLoader={!!disableLoader} />,
    [LaunchType.Monitor]: () => <MonitorLoader disableLoader={!!disableLoader} />
  }), [disableLoader]);

  if (!launchType || gameId === CCEuro24GameId) return null;

  const LoaderComponent = loaders[launchType];

  if (loaderStore.showIChancyLoader) return <IChancyLoader />;

  return LoaderComponent ? <LoaderComponent /> : <DefaultLoader isTronix={isTronix} hasPascalLoader={!!hasPascalLoader} />;
});
